var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 40,
    viewBox: "0 0 212 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11.6666H22.5C21.395 11.6666 20.3352 12.1056 19.5538 12.887C18.7724 13.6684 18.3334 14.7282 18.3334 15.8333V18.3333H15.8334V21.6666H18.3334V28.3333H21.6667V21.6666H24.1667L25 18.3333H21.6667V15.8333C21.6667 15.6123 21.7545 15.4003 21.9108 15.244C22.0671 15.0878 22.279 15 22.5 15H25V11.6666Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20C52 8.95431 60.9543 0 72 0C83.0457 0 92 8.95431 92 20C92 31.0457 83.0457 40 72 40C60.9543 40 52 31.0457 52 20Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3333 13.3333C80.3333 13.3333 79.75 15.0833 78.6666 16.1666C80 24.5 70.8333 30.5833 63.6666 25.8333C65.5 25.9166 67.3333 25.3333 68.6666 24.1666C64.5 22.9166 62.4166 18 64.5 14.1666C66.3333 16.3333 69.1666 17.5833 72 17.5C71.25 14 75.3333 12 77.8333 14.3333C78.75 14.3333 80.3333 13.3333 80.3333 13.3333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104 20C104 8.95431 112.954 0 124 0C135.046 0 144 8.95431 144 20C144 31.0457 135.046 40 124 40C112.954 40 104 31.0457 104 20Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.333 16.6666C128.659 16.6666 129.931 17.1934 130.869 18.1311C131.807 19.0688 132.333 20.3405 132.333 21.6666V27.5H129V21.6666C129 21.2246 128.824 20.8007 128.512 20.4881C128.199 20.1756 127.775 20 127.333 20C126.891 20 126.467 20.1756 126.155 20.4881C125.842 20.8007 125.667 21.2246 125.667 21.6666V27.5H122.333V21.6666C122.333 20.3405 122.86 19.0688 123.798 18.1311C124.736 17.1934 126.007 16.6666 127.333 16.6666Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119 17.5H115.667V27.5H119V17.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.333 15C118.254 15 119 14.2538 119 13.3333C119 12.4128 118.254 11.6666 117.333 11.6666C116.413 11.6666 115.667 12.4128 115.667 13.3333C115.667 14.2538 116.413 15 117.333 15Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156 20C156 8.95431 164.954 0 176 0C187.046 0 196 8.95431 196 20C196 31.0457 187.046 40 176 40C164.954 40 156 31.0457 156 20Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M180.167 11.6666H171.833C169.532 11.6666 167.667 13.5321 167.667 15.8333V24.1666C167.667 26.4678 169.532 28.3333 171.833 28.3333H180.167C182.468 28.3333 184.333 26.4678 184.333 24.1666V15.8333C184.333 13.5321 182.468 11.6666 180.167 11.6666Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M179.333 19.475C179.436 20.1685 179.318 20.8769 178.995 21.4992C178.672 22.1215 178.161 22.6262 177.535 22.9414C176.908 23.2566 176.199 23.3663 175.507 23.255C174.814 23.1436 174.175 22.8167 173.679 22.321C173.183 21.8252 172.856 21.1857 172.745 20.4935C172.634 19.8013 172.743 19.0916 173.059 18.4653C173.374 17.8391 173.879 17.3281 174.501 17.0052C175.123 16.6823 175.832 16.5638 176.525 16.6667C177.232 16.7716 177.887 17.1012 178.393 17.6069C178.899 18.1126 179.228 18.7676 179.333 19.475Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.583 15.4166H180.592",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootericon);
export default __webpack_public_path__ + "static/media/footericon.f52b8411a2f525f33fa667eda438a28f.svg";
export { ForwardRef as ReactComponent };